/* KFH build your install. Start (bundles, wig or crochet) -> that path's steps -> review -> one add to cart.
   State lives in the URL so links can open it pre-filled and refresh keeps picks:
   p (path) t (texture) l (length) n (bundles or packs) lm (lengths: same or mix = make your own) mx (each bundle's length, e.g. 16-18-20)
   c (closure id or 'none') cl (closure length) w (wig/crochet product id). */
(() => {
  const SHAPES = { straight: 0, body_wave: 1, loose_wave: 2, curly: 3 };
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-kfh-build-data]').textContent);
    const s = JSON.parse(root.querySelector('[data-kfh-build-strings]').textContent);
    const $ = (q) => root.querySelector(q);
    const $$ = (q) => [...root.querySelectorAll(q)];
    const money = (c) => window.KFH.money(c);
    const fill = (str, map) => Object.entries(map).reduce((a, [k, v]) => a.split(`[${k}]`).join(v), str || '');
    const lowest = (variants) => Math.min(...variants.filter((v) => v.available).map((v) => v.price));
    const lensOf = (p) => [...new Set(p.variants.filter((v) => v.available && v.n).map((v) => v.n))].sort((a, b) => a - b);

    // Bundle chart rows ("14 to 16 in | 2 bundles | 3 bundles") -> [{ max, natural, full }]
    const rows = (data.chart || '').split('\n').map((r) => (r.match(/\d+/g) || []).map(Number))
      .filter((n) => n.length >= 4).map(([, max, natural, full]) => ({ max, natural, full }));
    const counts = (len) => rows.find((r) => len <= r.max) || rows[rows.length - 1] || { natural: 3, full: 4 };

    // Paths with nothing to sell hide (a wig path with an empty collection, bundles with no textures).
    const paths = data.paths.filter((p) => (p.kind === 'bundles' ? data.textures.length : p.products.length));
    const STEPS = { bundles: ['start', 'texture', 'length', 'closure', 'review'], wig: ['start', 'item', 'review'], crochet: ['start', 'item', 'review'] };

    // Picks live in the URL so shared and quiz links open pre-filled. A refresh starts fresh.
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    const params = new URLSearchParams(nav && nav.type === 'reload' ? '' : location.search);
    const st = {
      step: 'start',
      p: (params.get('p') === 'sewin' ? 'bundles' : params.get('p')) || (params.get('t') ? 'bundles' : ''), // sewin: old links
      t: params.get('t'),
      l: Number(params.get('l')) || 0,
      n: Number(params.get('n')) || 0, // 0 = the recommended count
      c: params.get('c') || '',
      cl: Number(params.get('cl')) || 0,
      w: params.get('w') || '',
      lm: ['blend', 'mix'].includes(params.get('lm')) ? 'mix' : 'same', // blend: old links, now 16, 18, 20 made your own
      mix: (params.get('lm') === 'blend' ? '16-18-20' : params.get('mx') || '').split('-').map(Number).filter(Boolean),
    };
    if (!paths.some((p) => p.kind === st.p)) st.p = '';
    if (st.lm === 'mix' && st.mix.length) st.l = Math.max(...st.mix); // mixed: the advice follows the longest bundle
    // Old links: f=full meant the chart's "full" count.
    if (!st.n && params.get('f') === 'full' && st.l) st.n = counts(st.l).full;

    const path = () => paths.find((p) => p.kind === st.p);
    const steps = () => STEPS[st.p] || ['start', 'texture', 'length', 'closure', 'review'];
    const tex = () => (st.p === 'bundles' ? data.textures.find((t) => t.handle === st.t) : null);
    const noClosure = () => !!(tex() && !tex().closures.length);
    const item = () => {
      const pa = path();
      if (!pa || !pa.products.length) return null;
      return pa.products.find((x) => String(x.p.id) === st.w) || (pa.products.length === 1 ? pa.products[0] : null);
    };
    const picked = () => (st.p === 'bundles' ? !!tex() : st.p ? !!item() : false);
    const countMax = () => (st.p === 'bundles' ? 5 : (path() || {}).countMax || 1);
    const countRec = () => (st.p === 'bundles' ? counts(st.l || 18).natural : (path() || {}).countDefault || 1);
    const count = () => Math.min(st.n || countRec(), countMax());
    const cap = (x) => (x ? String(x).replace(/\b\w/g, (c) => c.toUpperCase()) : '');
    const countWord = (n) => (st.p === 'crochet' ? (n === 1 ? s.pack : fill(s.packs, { n })) : (n === 1 ? s.bundle : fill(s.bundles, { n })));

    /* ---------- what the picks add up to ---------- */
    // Friendly lines: "Monroe Signature Set" · "Body Wave · 18, 18, 18 in"; "Monroe bundle" · "Body Wave · 26 in".
    // compare = what the same bundles cost as singles, so a set's saving comes from real prices.
    const singleAt = (t, n) => t.single.variants.find((v) => v.n === n && v.available);
    const singleLines = (t, lens) => {
      const by = {};
      lens.forEach((n) => { by[n] = (by[n] || 0) + 1; });
      return Object.entries(by).map(([n, qty]) => {
        const v = singleAt(t, Number(n));
        return v && { id: v.id, qty, title: `${t.name} ${qty > 1 ? 'bundles' : 'bundle'}`, sub: `${cap(t.type)} · ${Array(qty).fill(n).join(', ')} in`, price: v.price, image: t.singleImage, photo: t.photo, lens: Array(qty).fill(Number(n)), step: 'length' };
      }).filter(Boolean);
    };
    const setLine = (t, v, lens) => ({
      id: v.id, qty: 1, title: `${t.name} Signature Set`, sub: `${cap(t.type)} · ${lens.join(', ')} in`, price: v.price, image: t.setImage, photo: t.photo,
      set: true, lens, compare: lens.reduce((a, n) => a + ((singleAt(t, n) || {}).price || 0), 0), step: 'length',
    });
    // Mixed lengths: one per bundle, default stepping down 2 in from her longest (3 at 20 in: 16, 18, 20).
    const mixLens = (n) => {
      const t = tex();
      const lens = lensOf(t.single);
      if (st.mix.length === n && st.mix.every((x) => lens.includes(x))) return st.mix;
      const out = Array.from({ length: n }, (_, i) => st.l - 2 * (n - 1 - i)).map((x) => (lens.includes(x) ? x : lens.reduce((a, b) => (Math.abs(b - x) < Math.abs(a - x) ? b : a))));
      st.mix = out;
      return out;
    };
    // Same length: 3+ = the Signature Set (+ singles past 3). Make your own: singles only (the store's automatic
    // discount covers 3+, so 16, 18, 20 costs the same as the blended set).
    const bundleItems = (n, mode = st.lm) => {
      const t = tex();
      if (!t || !st.l) return [];
      if (mode === 'mix') return singleLines(t, n === count() ? mixLens(n) : Array(n).fill(st.l));
      const setV = t.set && t.set.variants.find((v) => v.n === st.l && !v.blended && v.available);
      if (n >= 3 && setV) return [setLine(t, setV, [st.l, st.l, st.l]), ...singleLines(t, Array(n - 3).fill(st.l))];
      return singleLines(t, Array(n).fill(st.l));
    };
    const plan = () => {
      if (st.p === 'bundles') {
        const items = bundleItems(count());
        const cl = closure();
        if (cl) items.push({ id: cl.v.id, qty: 1, title: `${tex().name} ${cl.c.size} closure`, sub: `${cl.v.n} in`, price: cl.v.price, image: cl.c.image, photo: cl.c.hero || cl.c.image, closure: true, size: cl.c.size, step: 'closure' });
        return items;
      }
      const it = item();
      const v = it && it.p.variants.find((x) => x.n === st.l && x.available);
      if (!v) return [];
      const n = st.p === 'crochet' ? count() : 1;
      return [{ id: v.id, qty: n, title: it.name, sub: [it.sub ? it.sub.split(' · ')[0] : '', st.p === 'crochet' ? countWord(n) : '', `${v.n} in`].filter(Boolean).join(' · '), price: v.price, image: it.image, photo: it.hero, caption: st.p === 'crochet' ? countWord(n) : `${v.n} in`, step: 'item' }];
    };
    const closure = () => {
      const t = tex();
      if (!t || !st.c || st.c === 'none') return null;
      const c = t.closures.find((x) => String(x.p.id) === st.c);
      if (!c) return null;
      const v = c.p.variants.find((x) => x.n === st.cl && x.available) || bestClosureLength(c);
      return v ? { c, v } : null;
    };
    // Closure length: the longest available that isn't longer than the bundles, else the shortest.
    const bestClosureLength = (c) => {
      const ok = c.p.variants.filter((v) => v.available);
      return ok.filter((v) => v.n <= st.l).sort((a, b) => b.n - a.n)[0] || ok.sort((a, b) => a.n - b.n)[0];
    };
    // was = what it would cost with no saving; total = what they pay. Sets: 3 singles at that length minus the
    // set price (live prices). 3+ singles: the store's automatic bundle discount.
    const totalsOf = (items) => {
      const sum = items.reduce((a, i) => a + i.price * i.qty, 0);
      const bundles = items.filter((i) => !i.closure).reduce((a, i) => a + (i.set ? 3 : i.qty), 0);
      const set = items.find((i) => i.set);
      const setSaving = set ? Math.max(0, set.compare - set.price) : 0;
      const discount = st.p === 'bundles' && !set && bundles >= 3 ? data.savingsCents : 0;
      const total = sum - discount;
      return { items, total, was: total + setSaving + discount, savings: setSaving + discount, count: items.reduce((a, i) => a + i.qty, 0) };
    };
    const totals = () => totalsOf(plan());

    /* ---------- render ---------- */
    const pathFrom = (p) => (p.kind === 'bundles' ? Math.min(...data.textures.map((t) => lowest(t.single.variants))) : Math.min(...p.products.map((x) => lowest(x.p.variants))));
    const pathImage = (p) => p.image || (p.kind === 'bundles' ? (data.textures[1] || data.textures[0]).image : p.products[0].image);
    const renderPaths = () => {
      $('[data-kfh-path-list]').innerHTML = paths.map((p) => `<li><button type="button" class="kfh-build__card kfh-build__path" role="radio" aria-checked="${st.p === p.kind}" data-kfh-path="${p.kind}">
        <span class="kfh-build__card-img"><img src="${pathImage(p)}" alt="" loading="lazy" width="300" height="300"><span class="kfh-build__check" aria-hidden="true"></span></span>
        <span class="kfh-build__card-name">${p.title}</span>
        ${p.line ? `<span class="kfh-build__card-line">${p.line}</span>` : ''}
        <span class="kfh-build__card-price">${fill(s.from, { price: money(pathFrom(p)) })}</span></button></li>`).join('');
    };
    const renderTextures = () => {
      $('[data-kfh-tex-list]').innerHTML = data.textures.map((t) => `<li><button type="button" class="kfh-build__card" role="radio" aria-checked="${st.t === t.handle}" data-kfh-tex="${t.handle}">
          <span class="kfh-build__card-img"><img src="${t.image}" alt="" loading="lazy" width="300" height="300"><span class="kfh-build__check" aria-hidden="true"></span></span>
          <span class="kfh-build__card-type">${t.type}</span>
          <span class="kfh-build__card-name">${t.name}</span>
          ${t.line ? `<span class="kfh-build__card-line">${t.line}</span>` : ''}
          <span class="kfh-build__card-price">${fill(s.from, { price: money(lowest(t.single.variants)) })}</span></button></li>`).join('');
    };
    const chips = (lens) => lens.map((n) => `<button type="button" class="kfh-chip" role="radio" aria-checked="${st.l === n}" data-kfh-len="${n}"><span>${n} in</span>${data.landmarks[n] ? `<span class="kfh-chip__sub">${data.landmarks[n]}</span>` : ''}</button>`).join('');
    const fixLength = (lens) => { if (!lens.includes(st.l)) st.l = lens.includes(18) ? 18 : lens[Math.floor(lens.length / 2)]; };
    // Count cards, all the same shape: count, price, "Save $X" when there's a saving, and at most one tag
    // (Top-up for 1, Recommended, Extra full). Any count works.
    const countCards = (priceOf) => {
      const rec = countRec();
      const full = st.p === 'bundles' ? counts(st.l).full : 0;
      return Array.from({ length: countMax() }, (_, i) => i + 1).map((n) => {
        const price = priceOf(n);
        if (price == null) return '';
        const tag = n === rec ? s.recommended : n === full ? s.fuller : n === 1 && st.p === 'bundles' ? s.topup : '';
        const save = price.was > price.total ? fill(s.save, { amount: money(price.was - price.total) }) : '';
        return `<button type="button" class="kfh-build__count" role="radio" aria-checked="${count() === n}" data-kfh-count="${n}">
          <b>${countWord(n)}</b><span>${money(price.total)}</span>${save ? `<small>${save}</small>` : ''}${tag ? `<em>${tag}</em>` : ''}</button>`;
      }).join('');
    };
    const renderLengths = () => {
      const t = tex();
      if (!t) return;
      fixLength(lensOf(t.single));
      // Mixed lengths has a row per bundle (with a way back to one length); one length uses the chips.
      $('[data-kfh-lengths]').hidden = st.lm !== 'same';
      $('[data-kfh-lengths]').innerHTML = chips(lensOf(t.single));
      const mix = $('[data-kfh-mix]');
      mix.hidden = st.lm !== 'mix';
      if (st.lm === 'mix') {
        const lens = lensOf(t.single);
        mix.innerHTML = mixLens(count()).map((x, i) => `<div class="kfh-build__mix-row"><span>${fill(s.bundleN, { n: i + 1 })}</span><div class="kfh-chips kfh-build__lengths" role="radiogroup" aria-label="${fill(s.bundleN, { n: i + 1 })}">${lens.map((n) => `<button type="button" class="kfh-chip" role="radio" aria-checked="${x === n}" data-kfh-mix-i="${i}" data-kfh-mix-len="${n}"><span>${n} in</span></button>`).join('')}</div></div>`).join('')
          + `<button type="button" class="kfh-build__mixlink" data-kfh-lmode="same">${s.sameLink}</button>`;
      }
      const c = counts(st.l);
      $('[data-kfh-count-title]').textContent = st.lm === 'mix' ? s.countMixed : fill(s.countAt, { length: st.l });
      const help = $('[data-kfh-count-help]');
      // No closure in this texture (e.g. Virginia): don't promise "+ a closure" the next step can't offer.
      const helpText = fill(help.dataset.text, { length: st.l, natural: c.natural, full: c.full });
      help.textContent = noClosure() ? helpText.replace(/\s*\+\s*a closure/i, '') : helpText;
      $('[data-kfh-counts]').innerHTML = countCards((n) => { const items = bundleItems(n); return items.length ? totalsOf(items) : null; });
      if (!bundleItems(count()).length && st.lm !== 'same') { st.lm = 'same'; }
      // What that comes to: the set (and its saving) or the bundles. Same length offers a way out to mixing.
      const mixLink = st.lm === 'same' && count() > 1 ? `<button type="button" class="kfh-build__mixlink" data-kfh-lmode="mix">${fill(s.mixLink, { n: count() })}</button>` : '';
      $('[data-kfh-bundle-pick]').innerHTML = mixLink + bundleItems(count()).map((i) => `<div class="kfh-build__line">${i.image ? `<img src="${i.image}" alt="" width="56" height="56" loading="lazy">` : ''}<span><b>${i.title}</b><small>${i.sub}</small></span><span class="kfh-build__line-price">${money(i.price * i.qty)}${i.set && i.compare > i.price ? `<em>${fill(s.saves, { amount: money(i.compare - i.price) })}</em>` : ''}</span></div>`).join('');
    };
    const renderClosures = () => {
      const t = tex();
      if (!t) return;
      if (st.c && st.c !== 'none' && !t.closures.some((x) => String(x.p.id) === st.c)) st.c = '';
      // Nothing is picked for her: Next waits until she chooses a closure or the leave-out.
      const none = !t.closures.length;
      $('[data-kfh-closures]').hidden = none;
      $('[data-kfh-leaveout]').hidden = !none;
      $('[data-kfh-step="closure"] .kfh-build__help').hidden = none;
      $('#KfhBuildCl').textContent = none ? s.leaveoutTitle : s.closureTitle;
      $('[data-kfh-leaveout-title]').textContent = fill(s.noClosureTitle, { texture: t.name });
      $('[data-kfh-leaveout-text]').textContent = fill(s.noClosureText, { texture: t.name });
      const cards = t.closures.map((c) => {
        const v = String(c.p.id) === st.c ? (closure() || {}).v : bestClosureLength(c);
        const lens = c.p.variants.filter((x) => x.available);
        const on = String(c.p.id) === st.c;
        return `<li><button type="button" class="kfh-build__closure" role="radio" aria-checked="${on}" data-kfh-closure="${c.p.id}">
          <img src="${c.image || t.image}" alt="" width="80" height="80" loading="lazy">
          <span><b>${c.size}</b><small>${c.note}</small></span>
          <span class="kfh-build__line-price">${v ? fill(s.priceAt, { price: money(v.price), length: v.n }) : ''}</span></button>
          ${on && lens.length > 1 ? `<label class="kfh-build__cl-len">Length <select data-kfh-cl-len>${lens.map((x) => `<option value="${x.n}"${v && x.n === v.n ? ' selected' : ''}>${x.label}</option>`).join('')}</select></label>` : ''}</li>`;
      });
      cards.push(`<li><button type="button" class="kfh-build__closure kfh-build__closure--none" role="radio" aria-checked="${st.c === 'none'}" data-kfh-closure="none"><span><b>${s.noClosure}</b></span></button></li>`);
      $('[data-kfh-closures]').innerHTML = cards.join('');
    };
    // Wig / crochet step: product cards (only when there's a choice), lengths with prices, packs.
    const renderItem = () => {
      const pa = path();
      if (!pa || pa.kind === 'bundles') return;
      $('[data-kfh-item-title]').textContent = pa.stepTitle || pa.title;
      $('[data-kfh-item-help]').textContent = pa.stepHelp || '';
      $('[data-kfh-item-help]').hidden = !pa.stepHelp;
      const list = $('[data-kfh-item-list]');
      list.hidden = pa.products.length < 2;
      list.innerHTML = pa.products.map((x) => `<li><button type="button" class="kfh-build__card" role="radio" aria-checked="${item() === x}" data-kfh-item="${x.p.id}">
          <span class="kfh-build__card-img"><img src="${x.image}" alt="" loading="lazy" width="300" height="300"><span class="kfh-build__check" aria-hidden="true"></span></span>
          <span class="kfh-build__card-name">${x.name}</span>
          ${x.sub ? `<span class="kfh-build__card-line">${x.sub}</span>` : ''}
          <span class="kfh-build__card-price">${fill(s.from, { price: money(lowest(x.p.variants)) })}</span></button></li>`).join('');
      const it = item();
      // One product (crochet): show it at the top of the step.
      const head = $('[data-kfh-item-head]');
      head.hidden = !(it && pa.products.length < 2);
      if (it) head.innerHTML = `<img src="${it.image}" alt="" width="96" height="96"><span><b>${it.name}</b><small>${it.sub || ''}</small></span>`;
      $('[data-kfh-item-len-wrap]').hidden = !it;
      $('[data-kfh-item-count]').hidden = true;
      if (!it) return;
      fixLength(lensOf(it.p));
      $('[data-kfh-item-lengths]').innerHTML = it.p.variants.filter((v) => v.available && v.n).map((v) => `<button type="button" class="kfh-chip" role="radio" aria-checked="${st.l === v.n}" data-kfh-len="${v.n}"><span>${v.n} in</span><span class="kfh-chip__sub">${money(v.price)}</span></button>`).join('');
      if (pa.countMax > 1) {
        $('[data-kfh-item-count]').hidden = false;
        $('[data-kfh-item-count-title]').textContent = pa.countTitle;
        $('[data-kfh-item-count-help]').textContent = pa.countHelp;
        const v = it.p.variants.find((x) => x.n === st.l && x.available);
        $('[data-kfh-item-counts]').innerHTML = countCards((n) => (v ? { total: v.price * n, was: v.price * n } : null));
      }
    };
    const renderReview = () => {
      const tt = totals();
      const lines = tt.items.map((i) => `<li class="kfh-build__line">${i.image ? `<img src="${i.image}" alt="" width="64" height="64" loading="lazy">` : ''}<span><b>${i.title}</b><small>${i.sub}</small><button type="button" class="kfh-build__edit" data-kfh-goto="${i.step}">${s.edit}</button></span><span class="kfh-build__line-price">${money(i.price * i.qty)}</span></li>`);
      if (st.p === 'bundles' && st.c === 'none') lines.push(`<li class="kfh-build__line kfh-build__line--note"><span><b>${s.leaveoutLine}</b><button type="button" class="kfh-build__edit" data-kfh-goto="closure">${s.edit}</button></span></li>`);
      $('[data-kfh-review]').innerHTML = lines.join('');
      $('[data-kfh-total]').textContent = money(tt.total);
      $('[data-kfh-savings-row]').hidden = !tt.savings;
      $('[data-kfh-savings]').textContent = money(tt.savings);
      const left = data.freeShipCents - tt.total;
      $('[data-kfh-ship]').textContent = data.freeShipCents ? (left <= 0 ? s.freeShip : fill(s.shipLeft, { amount: money(left) })) : '';
    };
    // Textures without a closure: the closure step is the "Leave-out" step (pill, progress and heading agree).
    const stepName = (k) => (k === 'item' ? (path() || {}).short || '' : k === 'closure' && noClosure() ? s.leaveoutShort : s.steps[k]);
    const renderSteps = () => {
      const list = steps();
      const at = list.indexOf(st.step);
      $('[data-kfh-steps]').innerHTML = list.map((k, i) => {
        const off = (i === 1 && !st.p) || (i > 1 && !picked()) || (k === 'review' && st.p === 'bundles' && !st.c);
        return `<li><button type="button" data-kfh-goto="${k}" aria-current="${k === st.step}" class="${i < at ? 'is-done' : ''}"${off ? ' disabled' : ''}><span>${i + 1}</span>${stepName(k)}</button></li>`;
      }).join('');
      $('[data-kfh-progress-label]').textContent = fill(s.progress, { n: at + 1, total: list.length, step: stepName(list[at]) });
      $('[data-kfh-progress-bar]').style.width = `${((at + 1) / list.length) * 100}%`;
    };
    // "Monroe · 18, 18, 18 in · 5x5 closure" | was / total / saving | Back | Next (or Add to bag)
    const renderBar = () => {
      const tt = totals();
      let label = s.empty;
      if (st.p === 'bundles' && tex()) {
        const lens = tt.items.flatMap((i) => i.lens || []);
        const cl = tt.items.find((i) => i.closure);
        label = [tex().name, lens.length ? `${lens.join(', ')} in` : '', cl ? `${cl.size.replace(/ (HD )?lace$/, '')} ${s.closure}` : ''].filter(Boolean).join(' · ');
      } else if (item()) {
        label = [item().name, st.l ? `${st.l} in` : '', st.p === 'crochet' ? countWord(count()) : ''].filter(Boolean).join(' · ');
      }
      $('[data-kfh-bar]').hidden = false;
      $('[data-kfh-bar-items]').textContent = label;
      $('[data-kfh-bar-total]').textContent = tt.count ? money(tt.total) : '';
      $('[data-kfh-bar-was]').hidden = !tt.savings;
      $('[data-kfh-bar-was]').textContent = tt.savings ? money(tt.was) : '';
      $('[data-kfh-bar-save]').hidden = !tt.savings;
      $('[data-kfh-bar-save]').textContent = tt.savings ? fill(s.save, { amount: money(tt.savings) }) : '';
      $('[data-kfh-back]').hidden = st.step === 'start';
      const leaveout = st.step === 'closure' && noClosure();
      const needsClosure = st.step === 'closure' && !st.c && !leaveout;
      const ready = st.step === 'start' ? !!st.p : picked() && !needsClosure && (st.step === 'texture' || tt.count > 0);
      const next = $('[data-kfh-next]');
      next.textContent = leaveout ? s.leaveoutBtn : needsClosure ? s.pickClosure : !ready ? s.pick : st.step === 'review' ? s.add : s.next;
      next.disabled = !ready;
    };

    /* ---------- the picture: texture showcase, photo, length figure, flat lay ---------- */
    const box = $('[data-kfh-visual]');
    const layers = $$('[data-kfh-photo]');
    // Two stacked images: the new one loads underneath, then fades in over the old one.
    // onShow runs when the new photo actually appears (keeps the slideshow name in step with the photo).
    const showPhoto = (src, onShow) => {
      const on = layers.find((l) => l.classList.contains('is-on'));
      if (!src || (on && on.getAttribute('src') === src)) { if (onShow) onShow(); return; }
      const next = layers.find((l) => l !== on);
      const reveal = () => { next.classList.add('is-on'); if (on) on.classList.remove('is-on'); if (onShow) onShow(); };
      next.onload = reveal;
      if (next.getAttribute('src') === src && next.complete) reveal(); else next.src = src;
    };
    const setMode = (m) => { box.dataset.mode = m; };
    // Nothing picked yet: one texture at a time, full size, with its name; a new one every 3 seconds.
    let cycleTimer = null;
    let cycleI = 0;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    $('[data-kfh-showcase-dots]').innerHTML = data.textures.map(() => '<i></i>').join('');
    const cycleTick = () => {
      const i = cycleI % data.textures.length;
      const t = data.textures[i];
      showPhoto(t.photo, () => {
        $('[data-kfh-showcase-name]').textContent = `${t.name} · ${cap(t.type)}`;
        $$('[data-kfh-showcase-dots] i').forEach((d, k) => d.classList.toggle('is-on', k === i));
      });
      cycleI += 1;
    };
    const startCycle = () => {
      setMode('cycle');
      if (cycleTimer) return;
      cycleTick();
      if (!reduced) cycleTimer = setInterval(cycleTick, 3000);
    };
    const stopCycle = () => { clearInterval(cycleTimer); cycleTimer = null; };
    const renderVisual = () => {
      const t = tex();
      if (st.step === 'start' || (st.step === 'texture' && !t)) { startCycle(); return; }
      // Wig / crochet before a pick: that path's own product photo, not the texture slideshow.
      if (st.step === 'item' && !item()) { stopCycle(); setMode('photo'); showPhoto(((path() || {}).products || [])[0] && path().products[0].hero); return; }
      stopCycle();
      if (st.step === 'length' && t) {
        setMode('figure');
        $('[data-kfh-figthumb]').src = t.image;
        $('[data-kfh-figcap]').textContent = `${t.name} · ${cap(t.type)}`;
        if (window.KFH.drawFigure) {
          // Compact: dots, only the picked length labelled (the chips already list every landmark).
          window.KFH.drawFigure($('[data-kfh-figure]'), {
            len: st.l,
            shape: SHAPES[t.shape] || 0,
            compact: true,
            lengths: lensOf(t.single).map((n) => ({ n, label: data.landmarks[n] ? `${n} in · ${data.landmarks[n]}` : `${n} in` })),
            onPick: (m) => { st.l = m.n; st.cl = 0; render(); },
          });
        }
        return;
      }
      if (st.step === 'review') {
        setMode('flat');
        const items = plan();
        $('[data-kfh-flat]').dataset.n = items.length;
        $('[data-kfh-flat]').innerHTML = items.map((i) => `<figure><img src="${i.photo}" alt="" width="500" height="600" loading="lazy"><figcaption>${i.closure ? `${i.size} · ${i.sub}` : i.caption || `${i.lens.join(', ')} in`}</figcaption></figure>`).join('');
        return;
      }
      setMode('photo');
      const cl = closure();
      showPhoto(st.step === 'closure' && cl ? cl.c.hero || cl.c.image : t ? t.photo : item().hero);
    };
    const render = () => {
      if (!steps().includes(st.step)) st.step = 'start';
      $$('[data-kfh-step]').forEach((el) => { el.hidden = el.dataset.kfhStep !== st.step; });
      renderSteps();
      renderPaths();
      if (st.p === 'bundles') { renderTextures(); renderLengths(); renderClosures(); }
      renderItem();
      renderReview();
      renderBar();
      renderVisual();
      const p = new URLSearchParams();
      if (st.p) p.set('p', st.p);
      if (st.p === 'bundles' && st.t) p.set('t', st.t);
      if (st.p && st.p !== 'bundles' && item()) p.set('w', item().p.id);
      if (picked() && st.l) p.set('l', st.l);
      if (picked() && countMax() > 1) p.set('n', count());
      if (st.p === 'bundles' && st.lm !== 'same') p.set('lm', st.lm);
      if (st.p === 'bundles' && st.lm === 'mix') p.set('mx', st.mix.join('-'));
      if (st.p === 'bundles' && st.c) p.set('c', st.c);
      const cl = closure();
      if (cl) p.set('cl', cl.v.n);
      const keep = new URLSearchParams(location.search);
      ['view', 'preview_theme_id'].forEach((k) => keep.get(k) && p.set(k, keep.get(k)));
      history.replaceState(null, '', `${location.pathname}?${p}`);
      $('[data-kfh-reset]').hidden = !st.p;
    };
    let advance;
    // Move to a step by key, or by offset (+1 / -1).
    const go = (to) => {
      clearTimeout(advance);
      const list = steps();
      const i = typeof to === 'number' ? list.indexOf(st.step) + to : list.indexOf(to);
      st.step = list[Math.max(0, Math.min(list.length - 1, i))];
      render();
      const h = root.querySelector(`[data-kfh-step="${st.step}"] h2`);
      if (h) h.focus({ preventScroll: true });
      // Scrolled past the top (or tucked under the sticky header): bring the steps back into view below the header.
      if (root.getBoundingClientRect().top < 96) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    const autoNext = () => { clearTimeout(advance); advance = setTimeout(() => go(1), 300); }; // show the check, then move on

    /* ---------- events ---------- */
    root.addEventListener('click', async (e) => {
      const b = e.target.closest('button');
      if (!b || !root.contains(b)) return;
      const d = b.dataset;
      if (d.kfhPath) {
        if (st.p !== d.kfhPath) Object.assign(st, { p: d.kfhPath, t: null, w: '', l: 0, n: 0, c: '', cl: 0 });
        render(); autoNext(); return;
      }
      if (d.kfhTex) { if (st.t !== d.kfhTex) { st.t = d.kfhTex; st.c = ''; } render(); autoNext(); return; }
      if (d.kfhItem) { st.w = d.kfhItem; render(); return; }
      if (d.kfhLen) { st.l = Number(d.kfhLen); st.cl = 0; st.mix = []; render(); return; }
      if (d.kfhCount) { st.n = Number(d.kfhCount); st.mix = []; render(); return; }
      if (d.kfhLmode) { st.lm = d.kfhLmode; st.mix = []; render(); return; }
      if (d.kfhMixI) { mixLens(count()); st.mix[Number(d.kfhMixI)] = Number(d.kfhMixLen); st.l = Math.max(...st.mix); render(); return; }
      if (d.kfhClosure) {
        st.c = d.kfhClosure; st.cl = 0;
        if (d.kfhClosure === 'none' && noClosure()) { go(1); return; } // "Continue with a leave-out"
        render(); return;
      }
      if (d.kfhGoto) { go(d.kfhGoto); return; }
      if (b.hasAttribute('data-kfh-reset')) {
        Object.assign(st, { step: 'start', p: '', t: null, l: 0, n: 0, c: '', cl: 0, w: '', lm: 'same', mix: [] });
        go('start');
        return;
      }
      if (b.hasAttribute('data-kfh-back')) { go(-1); return; }
      if (b.hasAttribute('data-kfh-next') && st.step === 'closure' && noClosure()) { st.c = 'none'; go(1); return; }
      if (b.hasAttribute('data-kfh-next') && st.step !== 'review') { go(1); return; }
      if (b.hasAttribute('data-kfh-next')) {
        const err = $('[data-kfh-error]');
        b.disabled = true;
        b.textContent = s.adding;
        try {
          await window.KFH.addToCart(plan().map((i) => ({ id: i.id, quantity: i.qty })));
          err.hidden = true;
        } catch (ex) {
          err.textContent = ex.message;
          err.hidden = false;
        }
        b.disabled = false;
        b.textContent = s.add;
      }
    });
    // Desktop: hovering a texture card previews its photo; leaving the cards puts the pick back.
    const texList = $('[data-kfh-tex-list]');
    texList.addEventListener('mouseover', (e) => {
      const c = e.target.closest('[data-kfh-tex]');
      const t = c && data.textures.find((x) => x.handle === c.dataset.kfhTex);
      if (t) { stopCycle(); setMode('photo'); showPhoto(t.photo); }
    });
    texList.addEventListener('mouseleave', renderVisual);
    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-kfh-cl-len]')) { st.cl = Number(e.target.value); render(); }
    });

    $$('[data-kfh-step] h2').forEach((h) => h.setAttribute('tabindex', '-1'));
    // Pre-filled link: start at the first step that still needs an answer.
    if (st.p === 'bundles') st.step = !tex() ? 'texture' : params.get('c') ? 'review' : params.get('l') ? 'closure' : 'length';
    else if (st.p) st.step = item() && params.get('l') ? 'review' : 'item';
    render();
  };
  const boot = () => document.querySelectorAll('[data-kfh-build]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
